export enum ExpectedUsage {
    Centralized = 'centralized',
    DirectDownload = 'directDownload',
    OnPremise = 'onPremise',
    RedolPlatform = 'redolPlatform',
}

export const ExpectedUsageText = {
    [ExpectedUsage.Centralized]: 'In the Centralized Data Spaces',
    [ExpectedUsage.RedolPlatform]: 'In the REDOL Data Sharing Platform',
    // [ExpectedUsage.DirectDownload]: 'Through Direct Download in the Data Consumer’s Data Space',
    // [ExpectedUsage.OnPremise]: 'Only in the Data Provider’s On-Premise Data Space',
};

export const ExpectedUsageShortText = {
    [ExpectedUsage.Centralized]: 'Centralized',
    [ExpectedUsage.DirectDownload]: 'Direct Download',
    [ExpectedUsage.OnPremise]: 'On-Premise',
    [ExpectedUsage.RedolPlatform]: 'Redol Platform',
};
